import { render, staticRenderFns } from "./user-dashboard.vue?vue&type=template&id=0dbcebe5&scoped=true&"
import script from "./user-dashboard.vue?vue&type=script&lang=ts&"
export * from "./user-dashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbcebe5",
  null
  
)

export default component.exports